import { render, staticRenderFns } from "./seatList.vue?vue&type=template&id=fdf36ee4"
import script from "./seatList.vue?vue&type=script&lang=js"
export * from "./seatList.vue?vue&type=script&lang=js"
import style0 from "./seatList.vue?vue&type=style&index=0&id=fdf36ee4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports